import AnchorTabs from './anchorTabs';
export default AnchorTabs;
export { AnchorTabs };